<template>
    <div id="contact">
        <b-container class="contact-wrapper">
            <b-row>
                <b-col id="order1" class="bottomv mb-4" md="6">
                    <h2>{{ $t('contact.title') }}</h2>
                </b-col>
                <b-col id="order3" class="bottomv mb-4" md="6">
                    <h3>{{ $t('contact.subtitle2') }}</h3>
                </b-col>
                <b-col id="order2" md="6">
                    <h3 class="contact-text">{{ $t('contact.subtitle1') }}</h3>
                    <p><img src="../assets/icn_phone.svg" class="img-fluid" alt=""> (686) 262 1759</p>
                    <p><img src="../assets/icn_mail.svg" class="img-fluid" alt=""> <a class="email-link" href="mailto:ventas@lumberworks.mx"> ventas@lumberworks.mx</a></p>
                    
                </b-col>
                <b-col id="order4" md="6">
                    <p>{{ messageSend }}</p>
                    <div class="mb-3 form-floating">
                        <b-form-input id="input-1" v-model="name" placeholder="Name*" type="text"></b-form-input>
                        <label for="input-1">{{ $t('contact.name') }}*</label>
                    </div>
                    <div class="mb-3 form-floating">
                        <b-form-input id="input-2" v-model="email" placeholder="Email*" type="text"></b-form-input>
                        <label for="input-2">{{ $t('contact.mail') }}*</label>
                    </div>
                    <div class="mb-3 form-floating">
                        <b-form-input id="input-3" v-model="phone" placeholder="Phone*" type="text"></b-form-input>
                        <label for="input-3">{{ $t('contact.phone') }}</label>
                    </div>
                    <div class="mb-3"> 
                        <label for="input-3">{{ $t('contact.mesage') }}</label>
                        <b-form-textarea id="input-3" v-model="message" rows="2" max-rows="3"></b-form-textarea>
                    </div>
                    <b-form-input autocomplete="off" tabindex="-1" id="input-1" class="pet-field" v-model="pet" placeholder="Alimento de mascota" type="text"></b-form-input>
                    <b-button class="btn btn-modal" v-on:click="sendMessage">{{ $t('contact.submit') }}</b-button>
                </b-col>
                <b-col md="12">
                    <router-link class="privacy-link" :to="{ name: 'Privacy'}">{{ $t('contact.privacy') }}</router-link>
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>

<script>
import axios from 'axios'
    export default {
        data() {
            return {
                name: '',
                email: '',
                phone: '',
                message: '',
                pet:'',
                messageSend: ''
            }
        },
        methods: {
            sendMessage: async function(){
                var responseData
                if(this.name != '' && this.email != '' && this.pet == ''){
                    await axios.post('https://quattromg.com/lumberworks/phpmailer.php', {
                        name: this.name,
                        email: this.email,
                        phone: this.phone,
                        message: this.message
                    })
                    .then((response) => {
                        responseData = response.data
                    })
                    .catch((error) => {
                        /* eslint-disable no-console */
                        console.log(error);
                        /* eslint-enable no-console */
                    });
                    console.log(responseData);
                    if(responseData==200 || responseData=='200') {
                        this.$router.push({ name: 'Thanks'})
                    } else {
                        this.messageSend = 'Error al enviar mensaje, intenta mas tarde.'
                    }
                } else {
                    this.messageSend = 'Ingresa la información necesaria en los campos.'
                }
            }
        }
    }
</script>

<style scoped>
#contact{
    padding: 180px 35px 57px 35px;
}
.contact-wrapper{
    background-color: #503B2D;
    background-image: url('../assets/img_footer_shape.png') ;
    background-repeat: no-repeat;
    background-position: 95% 40% ;
    padding: 120px 185px 145px 185px;
    border-radius: 50px;
}
h2{
    color: #fff;
    font-weight: 300;
    font-size: 45px;
    padding-right: 10px;
}
h3{
    color: #fff;
    font-weight: 300;
    font-size: 30px;
}
p{
    color: #fff;
    font-weight: 300;
    font-size:  20px;
    margin-bottom: 0px;
}
.contact-text{
    margin-top: 50px;
    margin-bottom: 30px;
}
.btn{
    background: transparent;
    border: 1px solid #fff;
    border-radius: 40px;
    width: 187px;
    padding: 15px;
    font-weight: 400;
    font-size: 16px;
}
.btn:focus,
.btn:hover,
.btn:active{
    background: transparent;
    border: 1px solid #fff;
}

.email-link{
    text-decoration: none;
    color: #fff;
}
.privacy-link{
    color: #FFFFFF4D;
    text-decoration: none;
}
.form-floating > .form-control{
    background: transparent;
    border: none;
    border-bottom: #fff solid 1px;
    border-radius: 0;
    color: #fff;
    font-size: 20px;
    padding-left: 0;
    outline: none !important;
}
/* .form-floating > .form-control, .form-floating > .form-control-plaintext, .form-floating > .form-select {
    height: calc(4rem + 2px);
} */

.form-floating > .form-control:focus ~ label, .form-floating > .form-control:not(:placeholder-shown) ~ label, .form-floating > .form-control-plaintext ~ label, .form-floating > .form-select ~ label {
    color: rgba(var(--bs-body-color-rgb), 0.65);
    -webkit-transform: scale(0.85) translateY(-1rem) translateX(0rem);
    transform: scale(0.85) translateY(-1rem) translateX(0rem);
}

label{
    color: #fff;
    font-size: 20px;
}
textarea{
    background: transparent;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid #fff;
    outline: none;
    font-size: 20px;
    color: #fff;
}
input:focus,
input:active{
    outline: none !important;
    box-shadow: none !important;
}
.form-floating label{
    font-size: 20px;
    color: #fff !important;
    padding-left: 0;
}
.form-floating > .form-control:focus ~ label::after, .form-floating > .form-control:not(:placeholder-shown) ~ label::after, .form-floating > .form-control-plaintext ~ label::after, .form-floating > .form-select ~ label::after{
    background: transparent;
    color: #fff !important;
    padding-left: 0 !important;
}

/* MODAL */
.modal-wrapper{
    padding: 100px 10px;
}
.img-modal{
    margin-bottom: 28px;
}
.title-modal{
    margin-bottom: 0;
    font-family: 'Kanit', sans-serif;
    font-weight: 400;
    font-size: 40px;
}
.text-modal{
    margin-bottom: 0;
    font-family: 'Kanit', sans-serif;
    font-weight: 400;
    font-size: 30px;
    margin: auto;
    width: 70%;
}
.pet-field{
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    height: 0;
    width: 0;
    z-index: -1;
}

@media (max-width: 1300px){
    #contact{
        padding: 180px 35px 57px 35px;
    }
    .contact-wrapper{
        padding: 100px 125px 105px 125px;
        border-radius: 50px;
        background-size: 50%;
    }
}

@media (max-width: 992px){
    .benefits-wrapper{
        padding: 55px 117px;
    }
    .benefits-title{
        padding: 0 57px 70px 117px;
    }
}
@media (max-width: 768px){
    #contact{
        padding: 100px 15px 57px 15px;
    }
    .contact-wrapper{
        padding: 100px 30px 105px 30px;
        border-radius: 50px;
        background-size: 60%;
    }

    h2{
        font-size: 35px;
    }
    #order1{
        order:1;
    }
    #order2{
        order:2;
        margin-bottom: 50px;
    }
    #order3{
        order:3;
    }
    #order4{
        order:4;
    }
    .contact-text{
        margin-top: 10px;
        margin-bottom: 30px;
    }
    label,
    textarea,
    .form-floating label,
    form-floating > .form-control,
    p{
        font-size: 18px;
    }
}


</style>